<template>
  <SoPageWithHeader title="Summary">
    <SoButton
      type="text"
      title="Back to warrants"
      prepend-icon="arrow-left"
      class="mb-2 px-0"
      data-testid="warrants-comm-groups-back-btn"
      :to="{
        name: RouteNames.AdminServiceWarrants,
        params: { serviceName: $route.params.serviceName },
        query: { tab: 'accounts' },
      }"
    />

    <p
      class="mb-4 text-body-1 text-center"
      data-testid="warrants-comm-groups-account"
    >
      Account <strong>{{ accountNumber }}</strong>
    </p>

    <SoTabs
      v-model="currentTab"
      divider
      data-testid="warrants-comm-groups-tabs"
    >
      <SoTab title="Communications">
        <div class="pt-4">
          <WarrantsCommunicationGroupsTab />
        </div>
      </SoTab>
      <SoTab title="Account History">
        <div class="pt-4">
          <WarrantsAccountHistoryTab />
        </div>
      </SoTab>
    </SoTabs>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import WarrantsCommunicationGroupsTab from "./components/WarrantsCommunicationGroupsTab.vue"
  import WarrantsAccountHistoryTab from "./components/WarrantsAccountHistoryTab.vue"
  import { RouteNames } from "@/types/router"

  // Tab indices match the order the SoTab children are declared.
  export enum WarrantsCommunicationsTab {
    Groups = 0,
    History = 1,
  }

  // URL slug for each tab (index aligns with WarrantsCommunicationsTab) so the
  // active tab is reflected in the `?tab=` query — deep-linkable and restored
  // on back nav.
  const TAB_SLUGS = ["communications", "history"]

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoButton,
      SoTabs,
      SoTab,
      WarrantsCommunicationGroupsTab,
      WarrantsAccountHistoryTab,
    },
    data() {
      return {
        RouteNames,
      }
    },
    computed: {
      accountNumber(): string {
        return this.$route.params.accountNumber as string
      },
      // The active tab is driven by the `?tab=` query param.
      currentTab: {
        get(): WarrantsCommunicationsTab {
          const index = TAB_SLUGS.indexOf(this.$route.query.tab as string)
          return index === -1 ? WarrantsCommunicationsTab.Groups : index
        },
        set(tab: WarrantsCommunicationsTab) {
          // replace (not push) so switching tabs doesn't spam browser history.
          this.$router.replace({
            query: { ...this.$route.query, tab: TAB_SLUGS[tab] },
          })
        },
      },
    },
  })
</script>
